import * as React from 'react';

export type BarItemProps = {
	content?: string;
	children?: React.ReactNode;
};

const BarItem = ({ children }: BarItemProps) => {
	return <div className="m-bar-item">{children}</div>;
};

export default BarItem;
